import { render, staticRenderFns } from "./SystemRole.vue?vue&type=template&id=3650c1ba&scoped=true&"
import script from "./SystemRole.vue?vue&type=script&lang=js&"
export * from "./SystemRole.vue?vue&type=script&lang=js&"
import style0 from "./SystemRole.vue?vue&type=style&index=0&id=3650c1ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3650c1ba",
  null
  
)

export default component.exports